<template>
  <div class="request-form-wrapper">
    <h2 class="samples-header">Shipping Information</h2>
    <loading-spinner v-if="loading"></loading-spinner>
    <!-- HTML is loaded via XHR. -->
    <div class="request-form" :class="{ loading: loading }" ref="sampleMaterialFormWrapper" v-html="html">
    </div>
    <ul v-if="errors" class="errors">
      <li v-for="(messages, key) in errors" v-bind:key="key">
        <span v-for="(message, index) in messages" v-bind:key="index">
          {{ message }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import axios from 'axios';
import LoadingSpinner from '../atoms/loading_spinner.js';
import EventBus from '../event_bus';

export default {
  components: {
    LoadingSpinner,
  },
  props: [
    'active',
    'selections',
  ],
  mounted() {
    this.getForm();
  },
  data() {
    return {
      loading: false,
      html: '',
      errors: null,
    }
  },
  methods: {
    async getForm() {
      this.loading = true;

      const config = {
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      }

      try {
        const { data } = await axios.get('/configurator-module/api/template/form/materialSampleRequest', config);
        this.html = data;
      } catch(error) {
        console.error('Error getting form:', error)
      }

      this.loading = false;
      this.$emit('formLoaded');
    },
    async submit() {
      this.loading = true;
      const formElement = this.$refs.sampleMaterialFormWrapper.firstElementChild.form;
      // const jsValidationField = formElement.querySelector("input[name^='alojs']");

      // if (jsValidationField) {
      //   jsValidationField.value = jsValidationField.id;
      // }
      const formData = new FormData(formElement);
      const checkedSelections = this.selections.filter((selection) => selection.checked);
      const SKUs = checkedSelections.map((selection) => selection.sku);

      formData.append('fields[SKUs]', JSON.stringify(SKUs));

      try {
        this.$emit('isSubmitting', true);
        const { data } = await axios.post('/sprout-forms/entries/save-entry', formData);
        if (data.success) {
          EventBus.$emit('successfulSampleSubmission');
        } else if (data.errors) {
          this.errors = data.errors;
          console.error('Form submission error:', error)
        }
      } catch (error) {
        this.failure = true;
        if (error) {
          console.error('Form submission error.')
        }
      }
      this.loading = false;
      this.$emit('isSubmitting', false);
    },
  }
}
</script>
